import React, { memo, useCallback, useMemo, useState } from 'react';
import Checks, { ChecksGroup } from '../../../bootstrap/forms/Checks';
import FormGroup from '../../../bootstrap/forms/FormGroup';
import Input from '../../../bootstrap/forms/Input';
import Icon from '../../../icon/Icon';
import ListCategoryItemsModal from '../ListCategoryItems';

function CategoryItem({category, onChange, checked, showCategory}) {
  
  const onShowCategory = useCallback(() => showCategory(category),[])

  return(
    <div className='row g-3 py-2'>
      <div className='col-md-1 d-flex align-items-center justify-content-center'>
        <ChecksGroup>
          <Checks
            type='switch'
            id='categories'
            name='categories'
            value={category.id}
            onChange={onChange}
            checked={checked}
            isInline
          />
        </ChecksGroup>
      </div>
      <div className='col-md-1'>
        <img
          src={category.image_url}
          alt='Imagem'
          width={40}
          height={40}
        />
      </div>
      <div className='col-md-9'>
        <FormGroup>
          <Input value={category.name} disabled readOnly />
        </FormGroup>
      </div>
      <div className='col-md-1'>
        <a href='#' onClick={onShowCategory}>
          <Icon
            style={{ marginTop: 5 }}
            icon='RemoveRedEye'
            size='2x'// null || 'sm' || 'md' || 'lg' || '2x' || '3x' || '4x' || '5x' || '6x' || '7x' || '8x' || '9x' || '10x'
          />
        </a>
      </div>
    </div>
  );
}

const CategoryElement = memo(CategoryItem);

function ListCategories({
  hidden,
  products,
  categories,
  subCategories,
  categoriesSelected,
  productStatus,
  onChange,
  onToggleProductStatus,
  onChangeShowCategory,
}) {

  const [categoryModal, setcategoryModal] = useState(false)
  const [categoryShow, setcategoryShow] = useState(null)
  const [subcategoryShowModal, setsubcategoryShowModal] = useState(null)

  const Header = useMemo(() => (
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <p>#</p>
      </div>
      <div className='col-md-1'>
        <p>Imagem</p>
      </div>
      <div className='col-md-10'>
        <p>Nome</p>
      </div>
    </div>
  ), [])

  const onShowCategory = useCallback((category) => {
    setcategoryShow(category)
    onChangeShowCategory(true)
    setcategoryModal(true)
  },[])

  const onCloseCategory = useCallback(() => {
    onChangeShowCategory(false)
    setcategoryModal(false)
  },[])

  const onChangeShowSubCategory = useCallback((show) => {
    setsubcategoryShowModal(show)
  },[])

  if(!categoriesSelected) return null;
	return (
    <div 
      hidden={hidden}
    >
      { Header }

      <div 
        style={{ maxHeight: 400 }} 
        className='overflow-y'
      >
        {categories.map((category, index) => {
          return (
            <CategoryElement
              key={'ch_comp'+index}
              category={category}
              onChange={onChange}
              checked={categoriesSelected.includes(category.id)}
              showCategory={onShowCategory}
            />
          );
        })}
      </div>

      <ListCategoryItemsModal
        open={categoryModal}
        onClose={onCloseCategory}
        products={products}
        subCategories={subCategories}
        category={categoryShow}
        productStatus={productStatus}
        onToggleProductStatus={onToggleProductStatus}
        onChangeShowSubCategory={onChangeShowSubCategory}
      />
    </div>
	);
}

export default memo(ListCategories);
